import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { Tile } from '@/store/tiles/types.ts';

export const SUPPORTED_TILE_IN_WORKSPACE = [
  'Cash',
  'Swap',
  'Option',
  'FlexiForward',
  'TakeProfitOrder',
  'StopLossOrder',
  'FixingOrder',
  'Twap+Order',
  'NightjarOrder',
  'FalconOrder',
  'CallOrder',
  'TargetAccumulator',
  'ForwardAccumulator',
] as const;

export const SavedTileValidator = arkScope.type({
  tileId: 'string',
  tabId: 'string',
  // productType: type.enumerated(SUPPORTED_TILE_IN_WORKSPACE),
  productType:
    "'Cash'| 'Swap'| 'Option'| 'FlexiForward'| 'TakeProfitOrder'| 'StopLossOrder'| 'FixingOrder'| 'Twap+Order'| 'NightjarOrder'| 'FalconOrder'| 'CallOrder'| 'TargetAccumulator' | 'ForwardAccumulator'",
  x: 'number',
  y: 'number',
  h: 'number',
  w: 'number',
});

export type SavedTile = typeof SavedTileValidator.infer;

// export interface SavedTile {
//   tileId: string;
//   tabId: string;
//   productType: (typeof SUPPORTED_TILE_IN_WORKSPACE)[number];
//   x: number;
//   y: number;
//   h: number;
//   w: number;
// }

///////////
// UTILS //
///////////

export const isTileSupportedInWorkspace = (
  x: Tile,
): x is Omit<Tile, 'productType'> & { productType: SavedTile['productType'] } =>
  SUPPORTED_TILE_IN_WORKSPACE.includes(x.productType as SavedTile['productType']);
